import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core/dist/public-api';

export function matchingFieldValidator(
  control2: AbstractControl,
  labelErrorMessage: string,
  translate: TranslateService
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value !== control2.value) {
      let message;
      translate.get(['error.validation.match.label', labelErrorMessage]).subscribe((translations) => {
        message = translations[labelErrorMessage] + ' ' + translations['error.validation.match.label'];
      });
      return { invalidMatchField: { value: control.value, msg: message } };
    }
    return null;
  };
}
